import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { LoginService } from '../pages/login/login.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private _loginService: LoginService, private _router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    // La sesión vive en la cookie HttpOnly auth_token, que el JS no puede leer:
    // en vez de chequearla, se le pregunta al backend si hay una sesión válida.
    return this._loginService.getCurrentCached().pipe(
      map((data: any) => (data?.res == 1 ? true : this._router.parseUrl('/home/'))),
      catchError(() => of(this._router.parseUrl('/home/')))
    );
  }
}
